<template>
  <router-link :to="{ name: 'applications.show', params: { application_id: application.id } }">
    <div class="row">
      <div class="col-12 col-lg-8">
        <p class="text-truncate">
          <span class="strong">{{ application.client ? application.client.company : '' }}</span><br/>
          <span class="d-inline-block mt-1">{{ application.name }}</span>
        </p>
      </div>
      <div class="col-6 col-lg-4 text-lg-end">
        <p>
          <span class="data-label d-lg-none">PI Billing:</span>
          {{ application.proposal ? 'Yes' : 'No' }}
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    application: {
      required: true,
      type: Object
    }
  }
}
</script>
